export const googleAnalyticsConfigModule = angular
  .module('Q.config.google-analytics', [])

  /*
   * Fires off a page view to Google Analytics every time the state is changed.
   */
  .run(function ($rootScope, $location, $window, $log) {
    $rootScope.$on('$stateChangeSuccess', function () {
      if ($window.ga) {
        $log.debug('[GA]', 'Tracking page view of ' + $location.url());
        $window.ga('send', 'pageview', { page: $location.url() });
      }
    });
  });
